export const blockIconsAudioandvideoSubtitlesNew = (
	<span className='material-symbols-outlined'>subtitles</span>
);
